import {Grid, Typography} from '@mui/material';

import {Icon, IconType} from '../Icon/Icon';

interface Props {
  text: string;
  isValid: boolean;
}

export const ValidationText = ({text, isValid}: Props) => {
  const gray = 'gray';
  const color = isValid ? 'black' : gray;
  return (
    <Grid container flexDirection='row' alignItems='center'>
      {isValid ? (
        <Icon iconColor={color} minWidth='16px' size={'16px'} icon={IconType.Check} sx={{marginRight: '4px'}} />
      ) : (
        <Grid minHeight='16px' minWidth='16px' alignItems='center' marginRight='4px'>
          <Typography fontSize='14px' color={color} textAlign='center'>
            {'•'}
          </Typography>
        </Grid>
      )}
      <Typography fontSize='14px' color={color}>
        {text}
      </Typography>
    </Grid>
  );
};
